<kehe-phoenix-manage-list-page-title-layout
  pageTitle="Manage Transaction Types"
>
  <ng-template #actionsBlock>
    <kehe-phoenix-button
      classAttr="btn-primary btn-medium"
      (click)="openAddTransactionTypeModal()"
    >
      Add
    </kehe-phoenix-button>
    @if (showAddTransactionTypeModal) {
    <app-add-transaction-type-modal
      (closeModal)="closeAddTransactionTypeModal()"
    ></app-add-transaction-type-modal>
    }
  </ng-template>
</kehe-phoenix-manage-list-page-title-layout>
<div>
  <app-transaction-type-grid></app-transaction-type-grid>
</div>
